import React from 'react'

const Details = () => {
  return (
    <div>details-role</div>
  )
}

export default Details